import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'

// https://github.com/jusbrasil/chatlib/blob/7bdd819defe12601b2bfeec4af69f224bdcfa87d/src/config.js#L5
export const COOKIE_NAME = 'collapsed_ask_a_lawyer'

// https://github.com/jusbrasil/chatlib/blob/7bdd819defe12601b2bfeec4af69f224bdcfa87d/src/chatbot/index.js#L54-L56
function getCookieName(name?: string) {
  return `${COOKIE_NAME}-${name}`
}

// https://github.com/jusbrasil/chatlib/blob/7bdd819defe12601b2bfeec4af69f224bdcfa87d/src/chatbot/index.js#L159
function getCookieExpirationDays(logged: boolean) {
  return logged ? 15 : 7
}

export function getCollapsedWidgetCookie(name?: string) {
  return getCookie(null, getCookieName(name))
}

export function setCollapsedWidgetCookie(logged: boolean, name?: string) {
  const dt = new Date()
  const expireDays = getCookieExpirationDays(logged)
  const expiration = expireDays * 24 * 60 * 60 * 1000
  dt.setTime(dt.getTime() + expiration)
  return setJusbrasilCookie(null, getCookieName(name), 'true', {
    expires: dt,
  })
}
